const tokens = {
  pharmacist: {
    token: "pharmacist-token"
  }
};

const users = {
  "pharmacist-token": {
    roles: ["pharmacist", "admin"],
    introduction: "I am a pharmacist",
    avatar:
      "https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif",
    email: "pharmacist@pharmaflix.com"
  }
};

export default {
  login: res => {
    const token = res.body.token;
    const data = tokens[token];
    if (data) {
      return {
        code: 20000,
        data
      };
    }
    return {
      code: 60204,
      message: "Account and password are incorrect."
    };
  },
  getInfo: res => {
    const token = res.body.token;
    const info = users[token];

    if (info) {
      return {
        code: 20000,
        data: info
      };
    }
    return {
      code: 50008,
      message: "Login failed, unable to get user details."
    };
  },
  logout: () => {
    return {
      code: 20000,
      data: "success"
    };
  }
};
